import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';
import liff from '@line/liff';

const RegisterForm = ({ userProfile, onRegisterSuccess }) => {
  const [formData, setFormData] = useState({
    username: '',
    phoneNumber: '',
    email: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (userProfile) {
      // พยายามดึง Email จาก LINE ID Token (ถ้ามี permission)
      const idToken = liff.getDecodedIDToken();
      setFormData(prev => ({
        ...prev,
        email: idToken?.email || ''
      }));
    }
  }, [userProfile]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!formData.username.trim()) {
        setError('กรุณาระบุ Username');
        setLoading(false);
        return;
    }

    try {
        // ตรวจสอบ Username ซ้ำ
        const { data: existingUser, error: checkError } = await supabase
            .from('users')
            .select('id')
            .eq('username', formData.username.trim())
            .maybeSingle();
        
        if (checkError) throw checkError;
        if (existingUser) {
            setError('Username นี้ถูกใช้งานแล้ว กรุณาเปลี่ยนใหม่');
            setLoading(false);
            return;
        }

        // บันทึกข้อมูลสมาชิกใหม่
        const { data: newUser, error: insertError } = await supabase
            .from('users')
            .insert([{
                line_user_id: userProfile.userId,
                display_name: userProfile.displayName,
                picture_url: userProfile.pictureUrl,
                username: formData.username.trim(),
                email: formData.email.trim(),
                phone_number: formData.phoneNumber.trim()
            }])
            .select()
            .single();

        if (insertError) throw insertError;

        // แจ้งกลับไปที่ App.js ว่าสำเร็จ
        onRegisterSuccess(newUser);

    } catch (err) {
        console.error('Registration error:', err);
        setError('เกิดข้อผิดพลาดในการลงทะเบียน: ' + err.message);
    } finally {
        setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--color-bg)', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' }}>
      <div style={{ backgroundColor: '#fff', width: '100%', maxWidth: '450px', padding: '30px', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.08)' }}>
        
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <div style={{ width: '80px', height: '80px', margin: '0 auto 15px', borderRadius: '50%', overflow: 'hidden', border: '3px solid var(--color-primary)' }}>
                {userProfile?.pictureUrl ? (
                    <img src={userProfile.pictureUrl} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                    <div style={{ width: '100%', height: '100%', backgroundColor: 'var(--color-border)' }}></div>
                )}
            </div>
            <h2 style={{ margin: '0 0 5px 0', color: 'var(--color-primary)', fontSize: '24px' }}>ลงทะเบียนสมาชิก</h2>
            <p style={{ margin: 0, color: 'var(--color-text-muted)', fontSize: '14px' }}>ยินดีต้อนรับคุณ {userProfile?.displayName}</p>
        </div>

        {error && (
            <div style={{ backgroundColor: '#ffebee', color: '#d32f2f', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px', textAlign: 'center' }}>
                {error}
            </div>
        )}

        <form onSubmit={handleSubmit}>
            {/* Username */}
            <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--color-text)', fontSize: '14px', fontWeight: '600' }}>Username <span style={{ color: 'red' }}>*</span></label>
                <input 
                    type="text" 
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    placeholder="ตั้งชื่อผู้ใช้งาน (ภาษาอังกฤษ)"
                    required
                    style={{ width: '100%', padding: '14px', borderRadius: '10px', border: '1px solid var(--color-border)', fontSize: '16px', boxSizing: 'border-box', outlineColor: 'var(--color-primary)' }} 
                />
            </div>

            {/* Phone */}
            <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--color-text)', fontSize: '14px', fontWeight: '600' }}>เบอร์โทรศัพท์</label>
                <input 
                    type="tel" 
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    placeholder="08x-xxx-xxxx"
                    style={{ width: '100%', padding: '14px', borderRadius: '10px', border: '1px solid var(--color-border)', fontSize: '16px', boxSizing: 'border-box', outlineColor: 'var(--color-primary)' }} 
                />
            </div>

            {/* Email */}
            <div style={{ marginBottom: '30px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--color-text)', fontSize: '14px', fontWeight: '600' }}>อีเมล</label>
                <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="example@mail.com"
                    style={{ width: '100%', padding: '14px', borderRadius: '10px', border: '1px solid var(--color-border)', fontSize: '16px', boxSizing: 'border-box', outlineColor: 'var(--color-primary)' }} 
                />
            </div>

            <button 
                type="submit" 
                disabled={loading}
                style={{ 
                    width: '100%', 
                    padding: '16px', 
                    backgroundColor: 'var(--color-primary)', backgroundImage: 'var(--color-primary-gradient)', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '50px', 
                    fontSize: '18px', 
                    fontWeight: 'bold', 
                    cursor: loading ? 'not-allowed' : 'pointer', 
                    boxShadow: '0 4px 15px rgba(var(--color-primary-rgb), 0.3)',
                    transition: 'all 0.2s',
                    opacity: loading ? 0.7 : 1
                }}
            >
                {loading ? 'กำลังบันทึก...' : 'ยืนยันการลงทะเบียน'}
            </button>
        </form>
      </div>
    </div>
  );
};

export default RegisterForm;
